import { useDispatch } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { HandymanAppState } from './reducers';

export type AppDispatch = ThunkDispatch<HandymanAppState, any, AnyAction>;
export const useAppDispatch = () => useDispatch<AppDispatch>();